import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {
    centeredModalBoxSx,
    modalBackdropProps,
} from '../../utils/styles/modal.overlay';

const modalPaperSx = centeredModalBoxSx({
    width: { xs: 'min(calc(100% - 32px), 420px)', sm: 500 },
    p: 4,
});

export default function LogOutModal(props) {
    const { setOpen, open, handleLogout } = props

    return (
        <div>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="logout-modal-title"
                aria-describedby="logout-modal-description"
                BackdropProps={modalBackdropProps}
            >
                <Box sx={modalPaperSx}>
                    <Stack
                        id="logout-modal-description"
                        spacing={2.5}
                        alignItems="stretch"
                    >
                        <Typography
                            id="logout-modal-title"
                            sx={{
                                textAlign: 'center',
                                fontFamily: '"Poppins", sans-serif',
                                fontWeight: 500,
                                fontSize: '1.0rem',
                                lineHeight: 1.45,
                                color: 'var(--primary-text-color)',
                                px: 0.5,
                                mt: 1,
                                mb: 2,
                            }}
                        >
                            Are you sure you want to log out of your account?
                        </Typography>
                        <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={2}
                            justifyContent="center"
                            alignItems="stretch"
                            sx={{ pt: 0.5 }}
                        >
                            <Button
                                size="large"
                                variant="outlined"
                                onClick={() => handleLogout()}
                                sx={{
                                    fontSize: '0.9rem',
                                    lineHeight: 1.25,
                                    fontFamily: '"Poppins", sans-serif',
                                    fontWeight: 500,
                                    minWidth: { sm: 150 },
                                    py: 1.25,
                                    textTransform: 'none',
                                    borderColor: 'var(--primary-text-theme-color)',
                                    color: 'var(--primary-text-theme-color)',
                                    '&:hover': {
                                        borderColor: 'var(--primary-text-theme-color)',
                                        backgroundColor: 'rgba(255, 255, 255, 0.06)',
                                    },
                                }}
                            >
                                Yes
                            </Button>
                            <Button
                                size="large"
                                variant="contained"
                                onClick={() => setOpen(false)}
                                sx={{
                                    fontSize: '0.9rem',
                                    lineHeight: 1.25,
                                    fontFamily: '"Poppins", sans-serif',
                                    fontWeight: 500,
                                    minWidth: { sm: 150 },
                                    py: 1.25,
                                    textTransform: 'none',
                                    backgroundColor: 'var(--primary-button-background-color)',
                                    color: 'var(--primary-button-text-color)',
                                    opacity: 0.9,
                                    '&:hover': {
                                        backgroundColor: 'var(--primary-button-background-color)',
                                        opacity: 0.8,
                                    },
                                }}
                            >
                                No
                            </Button>
                        </Stack>
                    </Stack>
                </Box>
            </Modal>
        </div>
    );
}